/****************************************************************************
 * Convert a ten digit phone number to the format of (123)456-7890
 *
 * AUTHOR: ROD
 * DATE:
 * VERSION:
 *
 ***************************************************************************
 * MODIFICATIONS:
 *
 ***************************************************************************/
export function formatPhone(elem) {
    if (elem.value.length === 1 && elem.value !== "(") {
        elem.value = "(" + elem.value;
    }else if (elem.value.length === 4) {
        elem.value = elem.value + ")";
    } else if (elem.value.length === 8) {
        elem.value = elem.value + "-";
    }
};


export function formatAsPhone(elem) {
    if(elem.value === undefined){
        return;
    }

    let ph = elem.value.replace('(','');
    ph = ph.replace(')','');
    ph = ph.replace('-','');

    if (ph.length === 10) {
        ph = '(' + ph.substr(0, 3) + ')' + ph.substr(3, 3) + '-' + ph.substr(6, 4);
    }

    return ph;
};

/****************************************************************************
 * Format a date using a given seperator to month day year.
 * If no seperator is given then / is used.
 *
 * call from onKeyUp
 *
 * AUTHOR: ROD
 * DATE:   05/15/2014
 * VERSION:
 *
 ***************************************************************************
 * MODIFICATIONS:
 *
 ***************************************************************************/
export function dateFormat(d) {
    //var pK = event ? event.which : window.event.keyCode;
    var pK = null;
    if (pK === 191 && d.value.substring(d.value.length - 1, d.value.length) ==='/') { d.value = d.value.substring(0, d.value.length - 1); return; }
    var dt = d.value;
    var da = dt.split('/');
    for (var a = 0; a < da.length; a++) { if (da[a] !== +da[a]) da[a] = da[a].substr(0, da[a].length - 1); }
    if (da[0] > 12) { da[1] = da[0].substr(da[0].length - 1, 1); da[0] = '0' + da[0].substr(0, da[0].length - 1); }
    if (da[1] > 31) { da[2] = da[1].substr(da[1].length - 1, 1); da[1] = '0' + da[1].substr(0, da[1].length - 1); }
    if (da[2] > 9999) da[1] = da[2].substr(0, da[2].length - 1);
    dt = da.join('/');
    if (dt.length === 2 || dt.length === 5) dt += '/';
    d.value = dt;
};

export function dateFormatOld(elem, sep) {
    //Pass the backspace(8), tab(9), enter(13), esc (27), left/right arrow keys(37, 38)
    // because JS is a f***ked up language get the window event - even though it would seem
    //  to me that the keycode would be part of the element...idk - f*ck JS!
    var e = window.event;

    if (/^(8|9|13|27|37|38)$/.test("" + e.keyCode)) {
        return true;
    }

    if (typeof(sep) === 'undefined') {
        sep = '/'
    }

    if((elem.value != null) && (elem.value.length >0)){
        var w = elem.value.substring(elem.value.length - 1);

        if (elem.value.substring(elem.value.length - 1)  === '/') {
            elem.value = elem.value;
        }else{
            var x = elem.value.substring(1,2);

            if((elem.value.length === 2) && (elem.value.substring(1,2) != sep)) {
                if (elem.value > 12) {
                    elem.value = elem.value.substr(0,1) + sep + elem.value.substring(1);
                }
            } else if ((elem.value.length === 3) && (elem.value.substring(2, 3) != sep) && (elem.value.substring(1, 2) != sep)) {

                if (elem.value.substr(0,2)  > 12) {
                    elem.value = elem.value.substr(0,1) + sep + elem.value.substring(1) + sep;
                }else{
                    elem.value = elem.value.substr(0,2) + sep + elem.value.substring(2);
                }
            }else if (elem.value.length === 4) {
                if ((elem.value.substring(1, 2) == sep) && (elem.value.substring(3) != sep)) {
                    elem.value = elem.value + sep;
                }
            }else if(elem.value.length === 5) {
                if((elem.value.substring(1,2) == sep) && (elem.value.substring(4, 5) != sep)){
                    elem.value = elem.value.substring(0,5) + sep;
                } else if(elem.value.substring(2,3) == sep) {
                    // var l = elem.value.substring(4,5);
                    elem.value = elem.value + sep;
                }
            }else if (elem.value.length === 6) {
                if ((elem.value.substring(2, 3) == sep) && (elem.value.substring(5) != sep)) {
                    elem.value = elem.value.substring(0,6) + sep;
                }
            }
        }
    }
};
//shortcut to document.getElementById
export function get(item) {
	return document.getElementById(item);
};
//shortcut to document.createElement
export function create(item) {
	return document.createElement(item);
};
//clone item to modify without affecting original
export function clone(obj) {
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        var copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        var copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i]);
        }
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        var copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
        }
        return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
};
//returns number of days in month
export function daysInMonth(month,year) {
    return new Date(year, month, 0).getDate();
};
//returns true or false if n is a number
export function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};
//returns d as date string or today to change to valid date
export function toValidDateString(d) {
	if (isValidDateString(d)) {
		return d;
	} else {
		return todayString();
	}
};
//returns today in MM/dd/yyyy format
export function todayString() {
	var today = new Date();
	return toMMddyyyy(today);
};
//returns date or date string in MM/dd/yyyy string format
export function toMMddyyyy(date) {
	if (typeof date == "string")
		date = new Date(date);
	var dd = date.getDate();
	var mm = date.getMonth() + 1;
	var yyyy = date.getFullYear();
	if (dd < 10) {
		dd = '0' + dd;
	} 
	if (mm < 10) {
		mm = '0' + mm;
	} 
	return mm + '/' + dd + '/' + yyyy;
};
//returns true if string is a valid date format
export function isValidDateString(value) {
  return (value.match(dateRegEx) !== null);
};
//returns true if day of week is a weekend
export function isWeekend(date) {
	if (typeof date == "string")
		date = new Date(date);
	var day = date.getDay();
	if (day == 6 || day == 0) {
		return true;
	} else {
		return false;
	}
};

export function getBrowser() {
    var ua = navigator.userAgent, tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
};

//fix for IE11 not having .trim()
if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
    }
};

//fix for opening within visual studio
if (getBrowser() != 'MSIE 7') {
    if(!window.getComputedStyle){

        Window.prototype.getComputedStyle = (function () {
            var Push = Array.prototype.push;

            function getComputedStylePixel(element, property, fontSize) {
                var
                value = element.currentStyle[property].match(/([\d\.]+)(%|cm|em|in|mm|pc|pt|)/) || [0, 0, ''],
                size = value[1],
                suffix = value[2],
                rootSize;

                fontSize = fontSize != null ? fontSize : /%|em/.test(suffix) && element.parentElement ? getComputedStylePixel(element.parentElement, 'fontSize', null) : 16;
                rootSize = property == 'fontSize' ? fontSize : /width/i.test(property) ? element.clientWidth : element.clientHeight;

                return suffix == '%' ? size / 100 * rootSize :
                       suffix == 'cm' ? size * 0.3937 * 96 :
                       suffix == 'em' ? size * fontSize :
                       suffix == 'in' ? size * 96 :
                       suffix == 'mm' ? size * 0.3937 * 96 / 10 :
                       suffix == 'pc' ? size * 12 * 96 / 72 :
                       suffix == 'pt' ? size * 96 / 72 :
                       size;
            }

            function setShortStyleProperty(style, property) {
                var
                borderSuffix = property == 'border' ? 'Width' : '',
                t = property + 'Top' + borderSuffix,
                r = property + 'Right' + borderSuffix,
                b = property + 'Bottom' + borderSuffix,
                l = property + 'Left' + borderSuffix;

                style[property] = (style[t] == style[r] && style[t] == style[b] && style[t] == style[l] ? [ style[t] ] :
                                   style[t] == style[b] && style[l] == style[r] ? [ style[t], style[r] ] :
                                   style[l] == style[r] ? [ style[t], style[r], style[b] ] :
                                   [ style[t], style[r], style[b], style[l] ]).join(' ');
            }
            // tobi: we can not use native CSSStyleDeclaration ?
            function CSSStyleDeclaration(element) {
                var
                style = this,
                currentStyle = element.currentStyle,
                fontSize = getComputedStylePixel(element, 'fontSize');

                for (const property in currentStyle) {
                    Push.call(style, property == 'styleFloat' ? 'float' : property.replace(/[A-Z]/, function (match) {
                        return '-' + match.toLowerCase();
                    }));

                    if (property == 'width') style[property] = element.offsetWidth + 'px';
                    else if (property == 'height') style[property] = element.offsetHeight + 'px';
                    else if (property == 'styleFloat') style['float'] = currentStyle[property];
                    else if (/margin.|padding.|border.+W/.test(property) && style[property] != 'auto') style[property] = Math.round(getComputedStylePixel(element, property, fontSize)) + 'px';
                    else style[property] = currentStyle[property];
                }

                setShortStyleProperty(style, 'margin');
                setShortStyleProperty(style, 'padding');
                setShortStyleProperty(style, 'border');

                style.fontSize = Math.round(fontSize) + 'px';
            }

            CSSStyleDeclaration.prototype = {
                constructor: CSSStyleDeclaration,
                getPropertyPriority: function () {
                    throw Error('NotSupportedError: DOM Exception 9');
                },
                getPropertyValue: function (property) {
                    return this[property.replace(/-\w/g, function (match) {
                        return match[1].toUpperCase();
                    })];
                },
                item: function (index) {
                    return this[index];
                },
                removeProperty: function () {
                    throw Error('NoModificationAllowedError: DOM Exception 7');
                },
                setProperty: function () {
                    throw Error('NoModificationAllowedError: DOM Exception 7');
                },
                getPropertyCSSValue: function () {
                    throw Error('NotSupportedError: DOM Exception 9');
                }
            };

            return function (element) {
                return new CSSStyleDeclaration(element);
            };
        })();
    }
} else {
    getComputedStyle = (function () { });
};
export function getWindowHeight() {
	return window.innerHeight || document.documentElement.clientHeight || document.documentElement.scrollHeight;
};
export function getWindowWidth() {
	return window.innerWidth || document.documentElement.clientWidth || document.documentElement.scrollWidth;
};
export function scrollOffset(orientation) {
	orientation = orientation.toLowerCase();
	if (orientation == 'top') {
		var scrollTop = window.document.documentElement.scrollTop; //ie8
		if (scrollTop == 0) {
			return document.getElementsByTagName("body")[0].scrollTop;
		} else {
			return scrollTop;
		}
	} else if (orientation == 'left') {
		var scrollLeft = window.document.documentElement.scrollLeft; //ie8
		if (scrollLeft == 0) {
			return document.getElementsByTagName("body")[0].scrollLeft;
		} else {
			return scrollLeft;
		}
	}
	return 0;
};
export function stripPositionStyles(field) {
	field.style.position = 'static';
	field.style.top = '0px';
	field.style.left = '0px';
	field.style.display = 'inline';
	field.style.width = '105px';
};
export function showElement(element, displayType) {
    if (displayType == undefined) {
        displayType = 'block';
    }
    element.style.display = displayType;
};
export function hideElement(element) {
    element.style.display = 'none';
};
export function removeCSS(element, classtoremove) {
    if (element.className != undefined && element.className != '') {
        element.className = element.className.replace(classtoremove, '');
    }
};

//arrays for referencing (0 based index!)
//abbreviated days of week
export const dayAbbr = [ "Su", "Mo", "Tu", "Wd", "Th", "Fr", "Sa" ];
//month names
export const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
//regular express used to validate date strings
export const dateRegEx = /^(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.](19|20)\d\d$/;

/*
* PARAMETER:
*		async - boolean - should the db connection be opened in asynchronous mode or not.
*								  if parameter is undefined it will be set to True for backward compatibility
*								  to existing code.
*
*								  false waits for the data set to completely return from the db before proceeding
*								  this stop overlaps in the JS execution.
*
* MODIFICATIONS:
*		ROD - 12/11/2015: Added async parameter. 
*      ROD - 03/02/2017: Added check to see if fncComplete is defined before calling to stop IE throws errors
*/
export function post(path, params, fncSuccess, fncError, fncComplete, async) {
	if (async === undefined) {
		async = true;
	}

    var xhr;
    if (typeof window.XMLHttpRequest === 'function') {
        xhr = new XMLHttpRequest();
    } else {
        //xhr = new ActiveXObject('Microsoft.XMLHTTP');
        console.error('CCBH.js - POST - could not create xhr');
    }

    for (var i = 0; i < params.length; i++) {
            if (i == 0) {
                path += '?';
            } else {
                path += '&';
            }
            var field = get(params[i]);
            //if the data is sitting in a list
            if (field == undefined) {
                var data = params[i][1];
                if (data.length > 0) {
                    path += params[i][0] + '=' + encodeURIComponent(data.join(";"));
                }
            } else if (field.type == 'checkbox') {
                path += field.id + '=' + encodeURIComponent(field.checked);
            } else {
                path += field.id + '=' + encodeURIComponent(field.value);
            }
    }

    xhr.open('POST', encodeURI(path), async);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
            var headers = xhr.getAllResponseHeaders();
        }
        
        //ready?
        if (xhr.readyState != 4)
            return false;
        //get status:
        var result = JSON.parse(xhr.responseText);
        //maybe not successful?
        if (result[0]) {
            if (result[0]["Code"] !== 0) {
                fncError(result[0]["Message"]);
            } else {
                fncSuccess(result[0]);
            }
        } else if (result["Success"] === "True") {
            fncSuccess(result["Message"]);
        }

        if (fncComplete !== undefined) {
            fncComplete();
        }
    };
    xhr.send();
};

export function getDocumentHeight() {
    var body = document.body,
    html = document.documentElement;
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
};

export function getTodaysDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }
    return mm + '/' + dd + '/' + yyyy;
};

export function formatDate(dateString) {
    var formatted = new Date(dateString);
    var dd = formatted.getDate();
    var mm = formatted.getMonth() + 1;
    var yyyy = formatted.getFullYear();
    if (dd < 10) {
        dd = '0' + dd
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    return mm + '/' + dd + '/' + yyyy;
};

export function indexOfArray(array, item) {
    for (var i = 0; i < array.length; i++) {
        if (array[i] == item) { return i; }
    }
    return -1;
};

export function addListener(element, eventName, handler) {
    if (element.addEventListener) {
        element.addEventListener(eventName, handler, false);
    }
    else if (element.attachEvent) {
        element.attachEvent('on' + eventName, handler);
    }
    else {
        element['on' + eventName] = handler;
    }
};

export function removeListener(element, eventName, handler) {
    if (element.addEventListener) {
        element.removeEventListener(eventName, handler, false);
    }
    else if (element.detachEvent) {
        element.detachEvent('on' + eventName, handler);
    }
    else {
        element['on' + eventName] = null;
    }
};